const TOKEN_KEY = 'warung-digital-admin-token'

export function readAdminToken(): string | null {
  return globalThis.sessionStorage?.getItem(TOKEN_KEY) ?? null
}

export function saveAdminToken(token: string): void {
  globalThis.sessionStorage?.setItem(TOKEN_KEY, token)
}

export function clearAdminToken(): void {
  globalThis.sessionStorage?.removeItem(TOKEN_KEY)
}
